import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, type Theme } from "../lib/api";
import { unlockAudio } from "../lib/audio";
import { SOLO_ROUND_COUNTS, type SoloRoundCount } from "@themix/shared";

export default function SoloSetup() {
  const nav = useNavigate();
  const [themes, setThemes] = useState<Theme[]>([]);
  const [selected, setSelected] = useState<number[]>([]);
  const [mix, setMix] = useState(true);
  const [count, setCount] = useState<SoloRoundCount>(10);
  const [seconds, setSeconds] = useState(30);
  const [err, setErr] = useState("");

  useEffect(() => {
    void api<Theme[]>("/api/themes").then(setThemes);
  }, []);

  async function start() {
    setErr("");
    await unlockAudio();
    try {
      const round = await api("/api/solo/start", {
        method: "POST",
        body: JSON.stringify({
          themeIds: mix ? [] : selected,
          mixRandom: mix || selected.length === 0,
          roundCount: count,
          roundSeconds: seconds,
        }),
      });
      sessionStorage.setItem("themix_solo_round", JSON.stringify(round));
      nav("/solo/play");
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Erreur");
    }
  }

  return (
    <div className="grid gap-6 pt-4">
      <h1 className="font-display text-4xl">Partie solo</h1>
      <label className="flex items-center gap-2">
        <input type="checkbox" checked={mix} onChange={(e) => setMix(e.target.checked)} />
        Mélange aléatoire
      </label>
      {!mix && (
        <div className="flex flex-wrap gap-2">
          {themes.map((t) => {
            const on = selected.includes(t.id);
            return (
              <button
                key={t.id}
                type="button"
                onClick={() => setSelected((s) => (on ? s.filter((x) => x !== t.id) : [...s, t.id]))}
                className={`rounded-full px-3 py-1 text-sm border ${on ? "bg-gold text-ink" : "border-cream/30"}`}
              >
                {t.icon} {t.name} ({t.approvedCount ?? 0})
              </button>
            );
          })}
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {SOLO_ROUND_COUNTS.map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => setCount(n)}
            className={`rounded-2xl px-4 py-3 ${count === n ? "bg-mint text-ink" : "bg-ink-2"}`}
          >
            {n === 0 ? "Infini" : `${n} titres`}
          </button>
        ))}
      </div>
      <label className="grid gap-1 max-w-xs">
        Durée d’une manche
        <input
          type="range"
          min={15}
          max={60}
          value={seconds}
          onChange={(e) => setSeconds(Number(e.target.value))}
        />
        <span>{seconds} s</span>
      </label>
      {err && <p className="text-pink">{err}</p>}
      <button type="button" onClick={() => void start()} className="rounded-3xl bg-gold text-ink font-bold py-4 text-xl">
        C’est parti
      </button>
    </div>
  );
}
